/* eslint-disable */

//JS /examencheck

import $ from "jquery";

export class ExamencheckJS {

  constructor() {
    self = this;
    $(".sectie-start-quiz").hide();
    $(".vakken-sectie").hide();
    $(".niveau-repeater > .niveau input").on("change", function(){
    $(".vakken, .vakken-heading").hide();

    $(".vakken input").prop('checked', false);

    $("#examencheck > .sectie:last-child a.fl-button").attr('href', '');

    var cn = $(this).prop('class');
    let niveau = cn.split(' ')[0];
    $(".vakken-sectie").show();
    $(`.vakken.${niveau}`).show();
    $(`.vakken-heading.${niveau}`).show();

    $(".sectie.vakken-sectie").css({
        'opacity' : 1,
        'max-height' : 'auto',
        'min-height' : '100vh',
    });

    $('html, body').animate({
        scrollTop: $(".sectie.vakken-sectie").offset().top
    }, 1000);
});


$(".vakken input").on("change", function(){
  $(".sectie-start-quiz").show();
    $("#examencheck > .sectie:last-child a.fl-button").attr('href', $(this).attr('data-quiz-url'));

    $(".sectie.sectie-start-quiz").css({
        'opacity' : 1,
        'max-height' : 'auto',
        'min-height' : '100vh',
    });

    $('html, body').animate({
        scrollTop: $(".sectie.sectie-start-quiz").offset().top
    }, 1000);

});


$("#examencheck > .sectie-start-quiz a.fl-button").click(function(e){
    if ( !$(this).attr('href').length || $(this).attr('href') == '#'){
        e.preventDefault();
    }
});

}
}
